import { useQuery } from '@tanstack/react-query';
import * as ENDPOINTS from './endpoints';
import { useCustomMutation } from '@devd-client/devd/components';

export const QUERY_KEYS = {
  teamDetails: 'teamDetails',
  goals: 'goals',
  teamFavMetrics: 'teamFavMetrics',
  favTeam: 'favTeam',
  teamsPage: 'teamsPage',
  contributorTableMetrics: 'contributorTableMetrics',
  allProjects: 'allProjects',
  languages: 'languages',
  teamPage: 'teamPage',
  metricListHeatmap: 'metricListHeatmap',
  teammenu: 'teammenu',
  contributorTableCsv: 'contributorTableCsv',
  contributorTableMetricsForTeams: 'contributorTableMetricsForTeams',
  saveTeamMetrics: 'saveTeamMetrics',
  teamComparisonTeamsList: 'teamComparisonTeamsList',
  jobRolesList: 'jobRolesList',
};

export const useFetchTeamComparisonTeamsList = () => {
  return useQuery(
    [QUERY_KEYS.teamComparisonTeamsList],
    ENDPOINTS.getTeamComparisonTeamsList
  );
};

export const useTeamDetails = (
  team: string,
  setMemberCount: (member: number) => void
) => {
  return useQuery(
    [QUERY_KEYS.teamDetails, team],
    () => ENDPOINTS.getTeamDetails(team),
    {
      onSuccess: (data) => setMemberCount(data?.dto?.memberCount),
    }
  );
};
export const useSaveContributorTableMetricsMutationForTeams = () => {
  return useCustomMutation(
    [QUERY_KEYS.contributorTableMetricsForTeams],
    ENDPOINTS.postContributorTableMetricsForTeams
  );
};

export const useGetContributorTableMetricsForTeams = (team: string) => {
  return useQuery([QUERY_KEYS.contributorTableMetricsForTeams, team], () =>
    ENDPOINTS.getContributorTableMetricsForTeams(team)
  );
};

export const useContributorTableCsvMutation = () => {
  return useCustomMutation(
    [QUERY_KEYS.contributorTableCsv],
    ENDPOINTS.postContributorTableCsv
  );
};
export const useContributorTableMetrics = () => {
  return useQuery(
    [QUERY_KEYS.contributorTableMetrics],
    ENDPOINTS.getContributorTableMetrics
  );
};

export const useFetchJobRolesList = () => {
  return useQuery([QUERY_KEYS.jobRolesList], ENDPOINTS.getJobRolesList);
};

export const useFetchRepo = (source: string) => {
  return useQuery([QUERY_KEYS.allProjects, source], () =>
    ENDPOINTS.getAllRepos(source)
  );
};

export const useTeammenu = () => {
  return useQuery([QUERY_KEYS.teammenu], ENDPOINTS.getTeammenu);
};

export const useFetchLanguages = () => {
  return useQuery([QUERY_KEYS.languages], () => ENDPOINTS.getAllLanguages());
};

export const useGetGoals = (team: string) => {
  return useQuery([QUERY_KEYS.goals, team], () => ENDPOINTS.getAllGoals(team));
};

export const useGoalSettingsMutation = () => {
  return useCustomMutation([QUERY_KEYS.goals], ENDPOINTS.updateGoalSettings);
};

export const useTeamFavMetrics = (team: string) => {
  return useQuery(
    [QUERY_KEYS.teamFavMetrics, team],
    () => ENDPOINTS.getAllTeamMetrics(team),
    {
      enabled: !!team,
    }
  );
};

export const useFetchTeamsPage = () => {
  return useQuery([QUERY_KEYS.teamsPage], ENDPOINTS.getTeamsPage);
};

export const useFetchTeamPage = () => {
  return useQuery([QUERY_KEYS.teamPage], ENDPOINTS.getTeamPage);
};

export const useFetchMetricList = () => {
  return useQuery([QUERY_KEYS.metricListHeatmap], ENDPOINTS.getMetricsList);
};

export const useSaveTeamMetricsMutation = () => {
  return useCustomMutation(
    [QUERY_KEYS.saveTeamMetrics],
    ENDPOINTS.postTeamMetrics
  );
};
